import { render, staticRenderFns } from "./detailFAQPage.vue?vue&type=template&id=0b212d24&scoped=true&"
import script from "./detailFAQPage.vue?vue&type=script&lang=js&"
export * from "./detailFAQPage.vue?vue&type=script&lang=js&"
import style0 from "./detailFAQPage.vue?vue&type=style&index=0&id=0b212d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b212d24",
  null
  
)

export default component.exports